module.exports = __webpack_public_path__ + "img/done.f4c2ab11.svg";